'use client'

import { LinkifiedMessage } from '@marketplace-web/linkified-message/linkified-message-feature'

type Props = {
  text: string
  conversationId?: string
}

const MessageText = ({ text, conversationId }: Props) => {
  return (
    <LinkifiedMessage
      text={text}
      trackingData={{
        ...(conversationId && { thread_id: conversationId }),
      }}
    />
  )
}

export default MessageText
